import axios from 'axios';
import store from '../index';
import * as types from './mutation-types';
import config from '@/config';

const accountEndpoint = `${config.API_URL}/me`;
const loginEndpoint = `${config.API_URL}/auth/token`;
const clientEndpoint = `${config.API_URL}/client`;
const lookupEnpoint = `${config.API_URL}/lookups`;

export const updateUserInfo = ({ commit }) =>
  new Promise((resolve, reject) => {
    axios
      .get(accountEndpoint, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => {
        commit(types.SET_USER_INFO, response.data);
        resolve();
      })
      .catch(err => {
        // error on /Account so bad apikey -> logout user needed
        // commit(types.LOG_OUT);
        reject(err);
      });
  });

export const login = ({ commit }, JWT) =>
  new Promise((resolve, reject) => {
    axios
      .get(loginEndpoint, { headers: { Authorization: `Bearer ${JWT}` } })
      .then(response => {
        commit(types.SET_APIKEY, response.data.access_token);
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteAccount = ({ commit }) =>
  new Promise((resolve, reject) => {
    axios
      .delete(accountEndpoint, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(() => {
        commit(types.LOG_OUT);
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });

export const saveJWT = ({ commit }, JWT) =>
  new Promise(() => {
    commit(types.SET_USER_JWT, JWT);
  });

export const logout = ({ commit }) =>
  new Promise(resolve => {
    commit(types.LOG_OUT);
    resolve();
  });

export const forceApiKey = ({ commit }, apiKey) => {
  commit(types.SET_APIKEY, apiKey);
};

export const changeLanguage = ({ commit }, language) =>
  new Promise(resolve => {
    commit(types.SET_LANGUAGE, language);
    resolve();
  });

export const acceptCookies = ({ commit }) =>
  new Promise(resolve => {
    commit(types.SET_COOKIES);
    resolve();
  });

export const getSecretQuestions = ({ commit, getters }) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${lookupEnpoint}/secretquestions?language=${getters.userLanguage.toUpperCase()}`)
      .then(response => {
        const secretQuestions = response.data;
        commit(types.SET_SECRET_QUESTIONS, secretQuestions);
        resolve(secretQuestions);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });

export const getClientSecretQuestion = ({ getters }, token) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${clientEndpoint}/secretquestions/${token}?language=${getters.userLanguage.toUpperCase()}`)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });

export const setClientResetInfo = ({ commit }, { token, question, answer }) =>
  new Promise(resolve => {
    commit(types.SET_RESET_INFO, { token, question, answer });
    resolve();
  });

export const setClientRegisterInfo = ({ commit }, { emailKey, studyId, userInfo }) =>
  new Promise(resolve => {
    commit(types.SET_REGISTER_INFO, { password: userInfo.password, emailKey, studyId });
    resolve();
  });

export const clientRegister = ({ commit }, { emailKey, studyId, userInfo }) =>
  new Promise((resolve, reject) => {
    const data = {
      password: userInfo.password || store.getters.registerInfo.password,
      secret_question: userInfo.secret_question || "Comment s'appelait votre premier animal de compagnie ?",
      secret_answer: userInfo.secret_answer || 'Coucou',
    };
    const studyQuery = studyId ? `?studyId=${studyId}` : '';
    axios
      .patch(`${clientEndpoint}/emailKey/${emailKey}${studyQuery}`, data)
      .then(response => {
        commit(types.SET_APIKEY, response.data.apikey);
        resolve();
      })
      .catch(error => {
        reject(error.response.data);
      });
  });

export const clientRegisterCheck = (_, emailKey) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${clientEndpoint}/emailKey/${emailKey}/check`)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });

export const clientLogin = ({ commit }, { email, password }) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${clientEndpoint}/login?email=${encodeURIComponent(email)}&password=${password}`)
      .then(response => {
        commit(types.SET_APIKEY, response.data.apikey);
        resolve();
      })
      .catch(error => {
        reject(error.response.data);
      });
  });

export const clientRestLink = (_, email) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${clientEndpoint}/resetlink?email=${email}`)
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error.response.data);
      });
  });

export const clientResetPassword = ({ commit }, { token, password, answer }) =>
  new Promise((resolve, reject) => {
    const data = {
      password: password,
      secret_answer: answer,
    };
    axios
      .patch(`${clientEndpoint}/resetpassword/${token}`, data)
      .then(response => {
        commit(types.SET_APIKEY, response.data.apikey);
        commit(types.SET_USER_INFO, response.data);
        resolve();
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
